export default "__VITE_ASSET__9ad630bd__"